import moment from 'moment';
export function createDefaultMeetingInput() {
    return {
        subject: '',
        startDateTime: moment()
            .startOf('hour')
            .add(1, 'hour'),
        endDateTime: moment()
            .startOf('hour')
            .add(2, 'hour')
    };
}
